import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Pencil, Plus, Trash } from "@phosphor-icons/react";
import { read } from "fs";
import { t } from "i18next";
import { min } from "lodash";
import { format } from "path";

const config = {
  modelName: "treatment-session-types",
  modelPluralName: "treatment-session-types",
  endpoint: "treatment-session-types",  
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "name",
        label: "name",
        key: "name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "description",
        label: "description",
        key: "description",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "duration",
        label: "duration_months",
        key: "duration",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "price",
        label: "price",
        key: "price",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      }
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      // Name
      name: {
        type: ["string", "null"],
        title: t("name"),
      },
      // description
      description: {
        type: ["string", "null"],
        title: t("description"),
        format: "textarea",
      },
      duration: {
        type: "number",
        title: t("duration"),
        minimum: 1,
        default: 1,
      },
      session_number: {
        type: "number",
        title: t("session_number"),
        minimum: 1,
        default: 1,
      },
      price: {
        type: "number",
        title: t("price"),
        minimum: 0,
        default: 0,
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
      duration: {
        "ui:widget": "updown",
      },
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "name",
              cols: "col-6",
            },
            {
              name: "price",
              cols: "col-6",
            },
            {
              name: "description",
              cols: "col-12",
            },
            {
              name: "duration",
              cols: "col-6",
            },
            {
              name: "session_number",
              cols: "col-6",
            },            
          ],
        ],
      },
    ],
  },
};
export default config;
